module.exports = __webpack_public_path__ + "img/login.7fc30c18.svg";